import React from 'react';
import { CtaButton } from './CtaButton';
import { IMAGES, goToCheckoutSection } from '../lib/config';
const badges = ['📄 100% PDF', '⚡️ Entrega Inmediata', '📚 10 herramientas listas para usar'];
export function Hero() {
  return <header className="px-5 pb-10 pt-8" data-id="element-125" data-mp="9l34fchccc3z">
      <h1 className="text-center text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-126" data-mp="4lyxkshw2qgt">
        El sistema completo para administrar tu consultorio como un profesional.
      </h1>

      <button type="button" onClick={goToCheckoutSection} className="mt-6 block w-full overflow-hidden rounded-3xl border border-teal-400/30 bg-white/5 p-1.5 shadow-2xl shadow-black/40 transition active:scale-[0.99]" aria-label="Ver la oferta del Kit Consultorio Sencillo" data-id="element-127" data-mp="xanpc0x21jfw">
        <img src={IMAGES.product} alt="Kit Consultorio Sencillo: manual, herramientas en Excel, documentos en PDF y Word y recursos visuales" className="w-full rounded-2xl" data-id="element-128" data-mp="3d1scx40hhvwa" />
      </button>

      <p className="mt-6 text-center text-base leading-relaxed text-teal-50/90" data-id="element-129" data-mp="3j9ty8ric7ai4">
        Ahorrá horas cada semana con herramientas listas para usar que organizan
        presupuestos, costos, turnos, contratos y la gestión diaria de tu
        consultorio.
      </p>

      <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-130" data-mp="3e8wi0kgw0qj9">
        {badges.map(b => <li key={b} className="rounded-full border border-teal-400/30 bg-teal-500/10 px-3 py-1.5 text-xs font-semibold text-teal-100" data-id="element-131" data-mp="30hho3ilfz4xf">
            {b}
          </li>)}
      </ul>

      <CtaButton className="mt-6" subLabel="Acceso inmediato · Descarga al instante" data-id="element-132" data-mp="2ql6b0qe12b1x" />
    </header>;
}